var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('amp-video-iframe',{staticStyle:{"overflow":"visible","width":"100%"},attrs:{"data-block-on-consent":"","src":"https://live.primis-amp.tech/content/video/amp/videoIframe.php?s=120450","width":"16","height":"9","layout":"responsive"}})}
var staticRenderFns = []

export { render, staticRenderFns }